module.exports = __webpack_public_path__ + "static/media/peru.c0f69608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/peru.png
// module id = 1174
// module chunks = 0